import { Injectable, OnDestroy } from "@angular/core";
import { map, Observable, Subscription, combineLatest, observeOn, asyncScheduler } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { RequestApprovalTypeDetailsStore } from "../store/approval-type-details-store";

@Injectable({
    providedIn: 'root',
})

export class RequestTitleService implements OnDestroy {
    requestTitleText: string = '';
    subscriptions: Subscription = new Subscription();

    constructor(
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private translateService: TranslateService
    ) {
        this.initSubscription();
    }

    initSubscription() {
        this.subscriptions.add(this.translateService.stream('request').subscribe(translation => {
            this.requestTitleText = translation.main?.header?.title;
        }));
    }

    getFormatRequestTitleText(): Observable<string> {
        return combineLatest([this.requestApprovalTypeDetailsStore.getApprovalTypeId(),
        this.requestApprovalTypeDetailsStore.getApprovalTypes()])
            .pipe(
                observeOn(asyncScheduler),
                map(([apTypeId, apTypes]) => {

                    if (!apTypeId) {
                        return '';
                    }

                    const currentApprovalType = apTypes
                        .find(apType => (apType.apTypeId).toString() === apTypeId);

                    const currentApprovalTypeName =
                        currentApprovalType?.miApTypeName || currentApprovalType?.apTypeName || '';

                    return this.formatRequestText(currentApprovalTypeName);

                })
            )
    }


    private formatRequestText(approvalTypeName: string): string {
        const approvalWord: string = this.requestTitleText.trim().split(/\s+/).pop() ?? '';
        let cleanApprovalTypeName: string = '';

        const removeWord: string = [approvalWord, approvalWord.slice(1)].find(word =>
            word.length > 1 && approvalTypeName.includes(word)
        ) ?? '';

        cleanApprovalTypeName = approvalTypeName.split(/\s+/)
            .filter(apName => apName !== removeWord)
            .join(' ');

        return `${this.requestTitleText} ${cleanApprovalTypeName}`;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}

